<p class="m-0 px-4 italic" data-test-id="occupancy-group-booking-notice">
	{{ 'components.occupancy.group-booking-notice.start-text' | translate }}
	<a
		[href]="contactUrl()"
		class="text-link hover:text-black"
		data-test-id="contact-link"
		target="_blank"
	>
		{{ 'components.occupancy.group-booking-notice.link' | translate }}
	</a>
	{{ 'components.occupancy.group-booking-notice.end-text' | translate }}
</p>
